import { Seo } from "../components/Seo";
import { FadeUp, Eyebrow } from "../components/Reveal";
import { useSettings } from "../lib/SettingsContext";

const Section = ({ title, children }) => (
  <section className="space-y-4">
    <h2 className="font-display font-medium text-xl text-ink">{title}</h2>
    <div className="text-sm text-ink/70 leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function NoteLegaliPage() {
  const { settings } = useSettings();

  return (
    <div data-testid="note-legali-page">
      <Seo
        title="Note legali | V32 Group — V32 Bagni"
        description="Note legali e informazioni societarie di V32 Group — V32 Bagni, ristrutturazioni bagno in Ticino."
      />
      <div className="pt-32 md:pt-40 pb-20 lg:pb-28">
        <div className="max-w-3xl mx-auto px-6 sm:px-10">
          <Eyebrow>Documento legale</Eyebrow>
          <FadeUp>
            <h1 className="mt-6 font-display font-light text-4xl sm:text-5xl tracking-tight text-ink">
              Note legali
            </h1>
          </FadeUp>
          <FadeUp delay={0.1}>
            <div className="mt-12 space-y-10">
              <Section title="Informazioni societarie">
                {settings.legal_name || settings.address || settings.vat ? (
                  <ul className="space-y-2">
                    {settings.legal_name && <li><span className="text-ink font-medium">Ragione sociale:</span> {settings.legal_name}</li>}
                    {settings.address && <li><span className="text-ink font-medium">Sede:</span> {settings.address}</li>}
                    {settings.vat && <li><span className="text-ink font-medium">Numero IVA / IDE:</span> {settings.vat}</li>}
                    {settings.email && <li><span className="text-ink font-medium">Email:</span> {settings.email}</li>}
                    {settings.phone && <li><span className="text-ink font-medium">Telefono:</span> {settings.phone}</li>}
                  </ul>
                ) : (
                  <p className="text-ink/70">
                    Denominazione commerciale: V32 Group — V32 Manutenzioni Tecniche.
                    {settings.phone && <> Telefono: {settings.phone}.</>}
                    <br />
                    <span className="text-ink/50 italic">
                      I dati di registro commercio e IVA saranno pubblicati in questa
                      sezione a seguito della registrazione ufficiale.
                    </span>
                  </p>
                )}
              </Section>

              <Section title="Proprietà intellettuale">
                <p>
                  I contenuti di questo sito — testi, grafica, logotipo e fotografie
                  originali — sono di proprietà di V32 Group o utilizzati su
                  licenza. Le immagini contrassegnate come «ispirazione» provengono
                  da archivi fotografici con licenza d'uso e non rappresentano
                  lavori eseguiti da V32. È vietata la riproduzione senza consenso
                  scritto.
                </p>
              </Section>

              <Section title="Esclusione di responsabilità">
                <p>
                  Le informazioni pubblicate hanno carattere generale e non
                  costituiscono un'offerta vincolante. Condizioni, perimetro delle
                  lavorazioni e prezzi vengono definiti esclusivamente tramite
                  preventivo scritto a seguito di sopralluogo. V32 Group non assume
                  responsabilità per contenuti di siti terzi collegati tramite link.
                </p>
              </Section>

              <Section title="Diritto applicabile">
                <p>
                  Il rapporto tra l'utente e V32 Group è regolato dal diritto
                  svizzero. Foro competente: quello previsto dalla legge.
                </p>
              </Section>
            </div>
          </FadeUp>
        </div>
      </div>
    </div>
  );
}
